import React, { Component } from 'react'

export default class okcomp extends Component {
    render() {
        return (
            <div>
                <h1>ESTO ES LA SEGUNDA PRUEBA</h1>
            </div>
        )
    }
}
